var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      ref: "browse",
      attrs: {
        "data-source": _vm.dataSource,
        "book-year-select": _vm.bookYearSelect,
        "clear-view-settings-filters": _vm.clearViewSettingsFilters,
        "allow-view-button": _vm.allowViewButton,
        view: _vm.view,
      },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm._t(
        "browse-action-buttons",
        function () {
          return [
            _vm.bookYearSelect
              ? _c(
                  "div",
                  { staticClass: "bookyear-wrapper" },
                  [
                    _c("app-select-book-year", {
                      attrs: { value: _vm.selectedBookYear },
                      on: {
                        input: function ($event) {
                          return _vm.onBookYearChange($event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        { slot: "browse-action-buttons" }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }